import { ReactElement, useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'

import LoadingScreen from '@/components/Loader'
import SuspenseWrapper from '@/components/SuspenseWrapper'
import { AppRoutes } from '@routes'
import { UserProvider } from '@context/UserContext'
import { SurveyProvider } from '@context/SurveyContext'
import { LoadingProvider } from '@context/LoadingContext'
import { ErrorProvider } from '@context/ErrorContext'
import { preloadCriticalRoutes } from '@/components/LazyComponents'

const App = (): ReactElement => {
  // Preload critical routes after app initialization
  useEffect(() => {
    preloadCriticalRoutes()
  }, [])

  return (
    <ErrorProvider>
      <LoadingProvider>
        <UserProvider>
          <SurveyProvider>
            <SuspenseWrapper loadingMessage="アプリケーションを読み込んでいます...">
              <RouterProvider router={AppRoutes} />
            </SuspenseWrapper>
            <LoadingScreen />
          </SurveyProvider>
        </UserProvider>
      </LoadingProvider>
    </ErrorProvider>
  )
}

export default App
